// extracted by mini-css-extract-plugin
export default {"global_content":"global_content___tSAgF","img":"img___edN1p","caption":"caption___ZXx6Q","text":"text___tJm9B","animation":"animation___QvIRP"};